import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { buildGetUsersQueryKey } from "./useGetUsers";
import { toast } from "@shared/services/toast";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
type Props = {
  onSuccess?: () => void;
};

type Params = {
  name: string;
  email: string;
  timezone?: string;
  countryState: string;
  emailConfirmed: boolean;
  subscriptionPlanId: string;
  mlsId?: string;
  officeName?: string;
  phoneNumber?: string;
  enabledMlsProviders?: string[];
};

export const useCreateUser = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.userControllerCreateUser({
        createUserRequest: {
          name: params.name,
          email: params.email,
          timezone: params.timezone,
          countryState: params.countryState,
          emailConfirmed: params.emailConfirmed,
          subscriptionPlanId: params.subscriptionPlanId,
          mlsId: params.mlsId,
          officeName: params.officeName,
          enabledMlsProviders: params.enabledMlsProviders,
          phoneNumber: params.phoneNumber,
        },
      });
      queryClient.invalidateQueries({ queryKey: buildGetUsersQueryKey() });
      onSuccess?.();
      toast.success(`User created with email ${params.email}`);
      return response;
    },
    onError: async (error) => {
      console.error(`Failed to create user`, error);
      const apiError = await apiResponseErrorHandler(error);
      toast.error(`Failed to create user. ${apiError.errors[0]}`);
    },
  });

  return mutation;
};
